/**
 * Maxi — Oferta do Dia / Oferta Relâmpago
 * Todas as decisões de janela usam America/Sao_Paulo.
 */
(function () {
  'use strict';

  var TIME_ZONE = 'America/Sao_Paulo';
  var zonedFormatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23'
  });

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function zonedParts(date) {
    var values = {};
    zonedFormatter.formatToParts(date).forEach(function (part) {
      if (part.type !== 'literal') values[part.type] = Number(part.value);
    });
    return values;
  }

  function isoDate(parts) {
    return parts.year + '-' + pad(parts.month) + '-' + pad(parts.day);
  }

  function validIsoDate(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return '';
    var pieces = value.split('-').map(Number);
    var test = new Date(Date.UTC(pieces[0], pieces[1] - 1, pieces[2]));
    return test.getUTCFullYear() === pieces[0] &&
      test.getUTCMonth() === pieces[1] - 1 &&
      test.getUTCDate() === pieces[2] ? value : '';
  }

  function legacyCopy(value) {
    var field = document.createElement('textarea');
    field.value = value;
    field.setAttribute('readonly', '');
    field.style.position = 'fixed';
    field.style.opacity = '0';
    document.body.appendChild(field);
    field.select();

    var copied = false;
    try {
      copied = document.execCommand('copy');
    } catch (error) {
      copied = false;
    }

    field.remove();
    return copied ? Promise.resolve() : Promise.reject(new Error('Copy failed'));
  }

  class FlashSale extends HTMLElement {
    connectedCallback() {
      this.timerLabel = this.querySelector('[data-flash-timer-label]');
      this.accessibleTimer = this.querySelector('[data-flash-timer-accessible]');
      this.hours = this.querySelector('[data-flash-hours]');
      this.minutes = this.querySelector('[data-flash-minutes]');
      this.seconds = this.querySelector('[data-flash-seconds]');
      this.activeContent = this.querySelector('[data-flash-active-content]');
      this.copyButton = this.querySelector('[data-flash-copy]');
      this.copyStatus = this.querySelector('[data-flash-copy-status]');

      this.handleCopy = this.handleCopy.bind(this);

      if (this.copyButton) {
        this.copyButton.addEventListener('click', this.handleCopy);
      }

      this.updateWindow();
      this.interval = window.setInterval(this.updateWindow.bind(this), 1000);
    }

    disconnectedCallback() {
      window.clearInterval(this.interval);
      window.clearTimeout(this.copyTimeout);
      if (this.copyButton) {
        this.copyButton.removeEventListener('click', this.handleCopy);
      }
    }

    updateWindow() {
      var parts = zonedParts(new Date());
      var today = isoDate(parts);
      var productId = this.dataset.productId;
      var isSkuOverride = this.hasAttribute('data-sku-override');
      var campaignStart = validIsoDate(this.dataset.campaignStart);
      var campaignEnd = validIsoDate(this.dataset.campaignEnd);
      var outsideCampaign = (campaignStart && today < campaignStart) ||
        (campaignEnd && today > campaignEnd);

      if (outsideCampaign) {
        this.hidden = true;
        return;
      }

      if (!isSkuOverride && window.MaxiFlashSession && productId) {
        if (window.MaxiFlashSession.isConsumed(productId)) {
          this.hidden = true;
          this.setAttribute('data-flash-consumed', 'true');
          return;
        }
        window.MaxiFlashSession.markViewed(productId);
      }

      var endHour = Math.min(24, Math.max(1, Number(this.dataset.dailyEndHour) || 24));
      var nowSeconds = parts.hour * 3600 + parts.minute * 60 + parts.second;
      var endSeconds = endHour * 3600;
      var dailyWindowOpen = nowSeconds < endSeconds;

      // Preferência: ocultar o card quando a janela diária estiver fechada.
      if (!dailyWindowOpen) {
        this.hidden = true;
        return;
      }

      this.hidden = false;
      this.classList.remove('maxi-flash-sale--closed');
      if (this.activeContent) this.activeContent.hidden = false;

      var remaining = endSeconds - nowSeconds;
      this.timerLabel.textContent = 'Termina em';

      var hours = Math.floor(remaining / 3600);
      var minutes = Math.floor((remaining % 3600) / 60);
      var seconds = remaining % 60;
      this.hours.textContent = pad(hours);
      this.minutes.textContent = pad(minutes);
      this.seconds.textContent = pad(seconds);

      if (seconds === 0 || !this.accessibleTimer.textContent) {
        this.accessibleTimer.textContent = this.timerLabel.textContent + ': ' +
          hours + ' horas, ' + minutes + ' minutos e ' + seconds + ' segundos.';
      }
    }

    handleCopy() {
      var self = this;
      var code = this.copyButton.dataset.coupon || '';
      var copy = navigator.clipboard && window.isSecureContext
        ? navigator.clipboard.writeText(code)
        : legacyCopy(code);

      copy.then(function () {
        self.copyButton.textContent = 'Copiado';
        self.copyStatus.textContent = 'Código ' + code + ' copiado para a área de transferência.';
      }).catch(function () {
        self.copyButton.textContent = 'Selecionar';
        self.copyStatus.textContent = 'Não foi possível copiar automaticamente. Selecione o código exibido.';
      }).finally(function () {
        window.clearTimeout(self.copyTimeout);
        self.copyTimeout = window.setTimeout(function () {
          self.copyButton.textContent = 'Copiar';
        }, 2500);
      });
    }
  }

  if (!customElements.get('flash-sale')) {
    customElements.define('flash-sale', FlashSale);
  }
})();
